import { css, Theme } from "@emotion/react"

export const layout = css``

export const appBar = (theme: Theme) => css`
    position: sticky;
    top: 0;
    z-index: 2;
    height: ${theme.spacing(8)};
`

export const sidebar = (theme: Theme) => css`
    position: sticky;
    top: ${theme.spacing(8)};
    z-index: 1;
    float: left;
    margin-right: ${theme.spacing(3)};
    height: calc(100vh - ${theme.spacing(8)});
`

export const content = (theme: Theme) => css`
    padding: ${theme.spacing(2)};
`
